module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aspin20-15916b8ef829b7419b8d93c789fcbd68.jpg";